"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformacionIntereses = void 0;
var React = require("react");
var required_select_js_1 = require("../utils/required_select.js");
var reactstrap_1 = require("reactstrap");
var aviso_privacidad_stac_js_1 = require("../utils/aviso_privacidad_stac.js");
var Clases = require("../../clases_comunes");
var OpcionesList = require("../../opciones.js");
var TrianguloVerde = require("../../assets/img/VerdePng.png");
var InformacionIntereses = /** @class */ (function (_super) {
    __extends(InformacionIntereses, _super);
    function InformacionIntereses(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            infoacademica: new Clases.InfoAcademica(), infolaboral: new Clases.InfoLaboral,
            opcionesInteres: [], consentimiento: false, modalAvisoPriv: false,
            opcionesHabilidades: [{ value: "resolucionproblemas", label: "Resolución de problemas" },
                { value: "pensamientocritico", label: "Pensamiento crítico" },
                { value: "comunicacionespanol", label: "Comunicación en español" },
                { value: "comunicacioningles", label: "Comunicación en inglés" },
                { value: "responsabilidadetica", label: "Responsabilidad ética y profesional" },
                { value: "trabajoequipo", label: "Trabajo en equipo" },
                { value: "nuevosconocimientos", label: "Obtención y aplicación de nuevos conocimientos" },
                { value: "creacionvalor", label: "Creación de valor" }]
        };
        // METODOS
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.validarSubmit = _this.validarSubmit.bind(_this);
        _this.showAvisoPrivacidad = _this.showAvisoPrivacidad.bind(_this);
        _this.closeAvisoPrivacidad = _this.closeAvisoPrivacidad.bind(_this);
        return _this;
    }
    InformacionIntereses.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            infoacademica: this.props.infoacademica, infolaboral: this.props.infolaboral,
            opcionesInteres: this.props.opcionesInteres
        }, function () { _this.cargarPreguntasAll(); });
    };
    InformacionIntereses.prototype.cargarPreguntasAll = function () {
        var _this = this;
        var academicaI = this.state.infoacademica;
        Object.keys(academicaI).map(function (key, i) {
            _this.showNewQuestions("infaca-" + key, academicaI[key]);
        });
    };
    InformacionIntereses.prototype.handleChange = function (event) {
        if (event.target.name.startsWith("inflab")) {
            var tnameil = event.target.name.split("-");
            var dtolaboral = this.state.infolaboral;
            if (tnameil[1] === "salariomensual") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 9);
            }
            else if (tnameil[1] === "motivotrabajonr ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 999);
            }
            else if (tnameil[1] === "nombrejefeinmediato ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "cargojefeinmediato ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "emailjefeinmediato") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "motivoestudiar") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 999);
            }
            else {
                dtolaboral[tnameil[1]] = event.target.value;
            }
            this.setState({ infolaboral: dtolaboral });
            this.showNewQuestions(event.target.name, event.target.value);
        }
        else if (event.target.name.startsWith("infaca")) {
            var tnameia = event.target.name.split("-");
            var dtoacademica = this.state.infoacademica;
            if (tnameia[1] === "tiposcursos") {
                dtoacademica[tnameia[1]] = event.target.value.slice(0, 199);
            }
            else if (tnameia[1] === "nombretitulo") {
                dtoacademica[tnameia[1]] = event.target.value.slice(0, 199);
            }
            else if (tnameia[1] === "nomuniencurso") {
                dtoacademica[tnameia[1]] = event.target.value.slice(0, 29);
            }
            else if (tnameia[1] === "otrointeres") {
                dtoacademica[tnameia[1]] = event.target.value.slice(0, 99);
            }
            else {
                dtoacademica[tnameia[1]] = event.target.value;
            }
            this.setState({ infoacademica: dtoacademica });
            this.showNewQuestions(event.target.name, event.target.value);
        }
        else if (event.target.name === "checkConsentimiento") {
            this.setState({ consentimiento: !this.state.consentimiento });
        }
    };
    InformacionIntereses.prototype.handleSelectChange = function (selectedOption, selName) {
        var _this = this;
        if (selectedOption != null) {
            if (selName.name.startsWith("inflab")) {
                var tnameils = selName.name.split("-");
                var dtolaboral = this.state.infolaboral;
                dtolaboral[tnameils[1]] = selectedOption.value;
                this.setState({ infolaboral: dtolaboral }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
            else if (selName.name.startsWith("infaca")) {
                var tnameias = selName.name.split("-");
                var dtoacademica = this.state.infoacademica;
                var opcInteres = "";
                var opcionesIntEscape;
                if (tnameias[1] !== "interes") {
                    dtoacademica[tnameias[1]] = selectedOption.value;
                    opcionesIntEscape = this.state.opcionesInteres;
                }
                else {
                    opcionesIntEscape = selectedOption;
                    selectedOption.map(function (option) {
                        opcInteres = opcInteres + option.value + ",";
                    });
                    dtoacademica["interes"] = opcInteres;
                }
                this.setState({ infoacademica: dtoacademica, opcionesInteres: opcionesIntEscape }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
        }
    };
    InformacionIntereses.prototype.showNewQuestions = function (name, answer) {
        if (name.startsWith("inflab")) {
            var tnamels = name.split("-");
            var dtoinfolabshow = this.state.infolaboral;
            if (tnamels[1] === "situacionlaboral") {
                if (answer === "ND") {
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                }
                else if (answer === "BPT" || answer === "SE") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    if (answer === "PN") {
                        dtoinfolabshow["negociopropio"] = "S";
                    }
                }
                else if (answer === "PN") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["negociopropio"] = "S";
                }
                else if (answer === "TRD") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["nombreempresafactura"] = "";
                }
                else if (answer === "PEI") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                }
                else if (answer === "RDN") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["negociopropio"] = "S";
                }
            }
            else if (tnamels[1] === "motivond") {
            }
            else if (tnamels[1] === "relacioncarrera") {
                if (answer === "NR") {
                }
                else if (answer !== "" && answer !== null && answer !== "NR") {
                    dtoinfolabshow["motivotrabajonr"] = "";
                }
            }
            else if (tnamels[1] === "cargoempresa") {
                if (answer === "DO") {
                }
                else if (answer !== "" && answer !== null && answer !== "DO") {
                    dtoinfolabshow["niveldocencia"] = "";
                }
            }
            else if (tnamels[1] === "idiomatrabajo") {
                if (answer === "N" || answer === "" || answer === null) {
                    dtoinfolabshow["tipocomunicacion"] = "";
                }
                else if (answer !== "" && answer !== null && answer !== "N") {
                    //(document.getElementById("tipocomunpregunta") as HTMLInputElement).style.removeProperty("display");
                }
            }
            else if (tnamels[1] === "negociopropio") {
                if (answer === "N") {
                    dtoinfolabshow["dedicacionnp"] = "";
                    dtoinfolabshow["aniosnp"] = 0;
                    dtoinfolabshow["relacionnpcarrera"] = "";
                    dtoinfolabshow["sectornp"] = 0;
                    dtoinfolabshow["nombrenp"] = "";
                    dtoinfolabshow["productonp"] = "";
                }
            }
            else if (tnamels[1] === "idpais") {
                if (answer === 1) {
                    //(document.getElementById("localidad-empresa") as HTMLInputElement).style.removeProperty("display");
                }
                else if (answer !== 0 && answer !== null && answer !== 1) {
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                }
            }
            this.setState({ infolaboral: dtoinfolabshow });
        }
        else if (name.startsWith("infaca")) {
            var tnameas = name.split("-");
            var dtoinfoacashow = this.state.infoacademica;
            if (tnameas[1] === "estudiosadicionales") {
                if (answer === "S") {
                    //(document.getElementById("est-posteriores") as HTMLInputElement).style.removeProperty("display");
                }
                else if (answer !== "" && answer !== null && answer !== "S") {
                    dtoinfoacashow["tiposcursos"] = "";
                }
            }
            else if (tnameas[1] === "titulopostgrados") {
                if (answer === "S") {
                    dtoinfoacashow["tipopostgradoencurso"] = "";
                    dtoinfoacashow["modalidadpostencurso"] = "";
                    dtoinfoacashow["idpaisencurso"] = 0;
                    dtoinfoacashow["nomuniencurso"] = "";
                    dtoinfoacashow["iduniencurso"] = 0;
                    dtoinfoacashow["relacioncarrpostencurso"] = "";
                }
                else if (answer === "N" || answer === "B") {
                    dtoinfoacashow["modalidadpost"] = "";
                    dtoinfoacashow["idpais"] = 0;
                    dtoinfoacashow["relacioncarrera"] = "";
                    dtoinfoacashow["tipopostgradoencurso"] = "";
                    dtoinfoacashow["modalidadpostencurso"] = "";
                    dtoinfoacashow["idpaisencurso"] = 0;
                    dtoinfoacashow["nomuniencurso"] = "";
                    dtoinfoacashow["relacioncarrpostencurso"] = "";
                    dtoinfoacashow["iduniencurso"] = 0;
                    dtoinfoacashow["nombretitulo"] = "";
                }
                else if (answer === "C") {
                    dtoinfoacashow["nombretitulo"] = "";
                    dtoinfoacashow["modalidadpost"] = "";
                    dtoinfoacashow["idpais"] = 0;
                    dtoinfoacashow["relacioncarrera"] = "";
                }
                else if (answer === "NI") {
                    dtoinfoacashow["modalidadpost"] = "";
                    dtoinfoacashow["idpais"] = 0;
                    dtoinfoacashow["relacioncarrera"] = "";
                    dtoinfoacashow["tipopostgradoencurso"] = "";
                    dtoinfoacashow["modalidadpostencurso"] = "";
                    dtoinfoacashow["idpaisencurso"] = 0;
                    dtoinfoacashow["nomuniencurso"] = "";
                    dtoinfoacashow["relacioncarrpostencurso"] = "";
                    dtoinfoacashow["interesadoespol"] = "";
                    dtoinfoacashow["iduniencurso"] = 0;
                    dtoinfoacashow["nombretitulo"] = "";
                }
            }
            else if (tnameas[1] === "idpaisencurso") {
                if (answer === 1) {
                    //(document.getElementById("unipostcurselect") as HTMLInputElement).style.removeProperty("display");
                    //(document.getElementById("unipostcur") as HTMLInputElement).style.display = "none";
                    //(document.getElementById("unipostcur") as HTMLInputElement).value = "";
                    dtoinfoacashow["nomuniencurso"] = "";
                }
                else if (answer !== 0 && answer !== null && answer !== 1) {
                    //(document.getElementById("unipostcur") as HTMLInputElement).style.removeProperty("display");
                    //(document.getElementById("unipostcurselect") as HTMLInputElement).style.display = "none";
                    dtoinfoacashow["iduniencurso"] = 0;
                }
            }
            else if (tnameas[1] === "interes") { // estos display si se quedan
                if (dtoinfoacashow.interes.indexOf("O") !== -1) {
                    document.getElementById("otrointeresdiv").style.removeProperty("display");
                }
                else if (dtoinfoacashow.interes !== "" && dtoinfoacashow.interes !== null && dtoinfoacashow.interes.indexOf("O") === -1) {
                    document.getElementById("otrointeresdiv").style.display = "none";
                    document.getElementById("otrointeres").value = "";
                    dtoinfoacashow["otrointeres"] = "";
                }
            }
            else if (tnameas[1] === "habilidadadquirida") {
                if (this.state.infolaboral.situacionlaboral === "BPT" || this.state.infolaboral.situacionlaboral === "SE" || this.state.infolaboral.situacionlaboral === "ND" || this.state.infolaboral.situacionlaboral === "PN") {
                    dtoinfoacashow["habilidadadquirida"] = "NA";
                }
            }
            else if (tnameas[1] === "habilidaddeseada") {
                if (this.state.infolaboral.situacionlaboral === "BPT" || this.state.infolaboral.situacionlaboral === "SE" || this.state.infolaboral.situacionlaboral === "ND" || this.state.infolaboral.situacionlaboral === "PN") {
                    dtoinfoacashow["habilidaddeseada"] = "NA";
                }
            }
            this.setState({ infoacademica: dtoinfoacashow });
        }
    };
    InformacionIntereses.prototype.validarSubmit = function (event) {
        event.preventDefault();
        this.props.handleSubmit(event, this.state.infolaboral, this.state.infoacademica);
    };
    InformacionIntereses.prototype.showAvisoPrivacidad = function (event) {
        event.preventDefault();
        this.setState({ modalAvisoPriv: true });
    };
    InformacionIntereses.prototype.closeAvisoPrivacidad = function () {
        this.setState({ modalAvisoPriv: false });
    };
    InformacionIntereses.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { id: "avisoModalContent", isOpen: this.state.modalAvisoPriv, toggle: this.closeAvisoPrivacidad, size: "xl", centered: true },
                React.createElement(reactstrap_1.ModalHeader, { className: "modal-header-style" }, "Aviso de privacidad de datos personales de alumni"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement(aviso_privacidad_stac_js_1.default, null)),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("button", { type: "button", className: "btn btn-light close-button", onClick: this.closeAvisoPrivacidad }, "Cerrar"))),
            React.createElement("form", { id: "alumniform-interes", name: "alumniform-interes", onSubmit: this.validarSubmit },
                React.createElement("div", { className: "green-border", style: { paddingLeft: "20px", paddingRight: "20px" } },
                    React.createElement("div", { id: "informacion-interes" },
                        React.createElement("div", { className: "form-group row section-title" },
                            React.createElement("div", { style: { backgroundColor: "white" } },
                                React.createElement("img", { src: TrianguloVerde, alt: "", className: "small-icon", style: { width: "50px", height: "50px" } }),
                                React.createElement("h5", { className: "down green-text small-h5title" }, "INTERESES Y V\u00CDNCULO CON ESPOL"))),
                        React.createElement("br", null),
                        React.createElement("div", { className: "form-group row" },
                            React.createElement("div", { className: "col-sm-12" },
                                React.createElement("label", { className: "control-label", htmlFor: "interesesalum" },
                                    "\u00BFQu\u00E9 tipo de actividad(es) le gustar\u00EDa tener o mantener como alumni de ESPOL? ",
                                    React.createElement("span", { className: "required-field" }, "*")),
                                React.createElement(required_select_js_1.default, { options: OpcionesList.InteresList, name: "infaca-interes", id: "interesesalum", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.opcionesInteres ? this.state.opcionesInteres : '', isDisabled: false, required: true, isMulti: true }))),
                        React.createElement("div", { className: "form-group row", id: "otrointeresdiv", style: { display: "none" } },
                            React.createElement("div", { className: "col-sm-12" },
                                React.createElement("textarea", { className: "form-control form-control-sm", value: this.state.infoacademica.otrointeres, name: "infaca-otrointeres", id: "otrointeres", rows: 3, maxLength: 99, placeholder: "Escriba otros intereses...", onChange: this.handleChange, style: { fontSize: "small" } }))),
                        React.createElement("div", { className: "form-group row" },
                            React.createElement("div", { className: "col-sm-12" },
                                React.createElement("label", { className: "control-label", htmlFor: "informacionsalum" },
                                    "\u00BFEst\u00E1 de acuerdo en recibir informaci\u00F3n institucional y oportunidades dirigidas a alumni de ESPOL? ",
                                    React.createElement("span", { className: "required-field" }, "*")),
                                React.createElement(required_select_js_1.default, { options: OpcionesList.YesNoList, name: "infaca-enviarinformacion", id: "informacionsalum", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infoacademica.enviarinformacion ? this.state.infoacademica.enviarinformacion : '', isDisabled: false, required: true, isMulti: false }))),
                        React.createElement("br", null),
                        React.createElement("div", { className: "col-12" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement("p", { style: { fontWeight: "bold" } },
                                    "AVISO DE PRIVACIDAD ",
                                    React.createElement("span", { className: "required-field" }, "*"))),
                            React.createElement("div", { className: "form-group form-check" },
                                React.createElement("input", { type: "checkbox", className: "form-check-input", id: "checkConsentimiento", name: "checkConsentimiento", onChange: this.handleChange, checked: this.state.consentimiento, required: true }),
                                React.createElement("label", { className: "form-check-label", htmlFor: "checkConsentimiento", style: { textAlign: "justify", fontSize: "small", fontWeight: "unset" } },
                                    "He le\u00EDdo y acepto la ",
                                    React.createElement("a", { onClick: this.showAvisoPrivacidad, style: { textDecoration: "underline", color: "#223163", cursor: "pointer" } }, "pol\u00EDtica de privacidad"),
                                    "."),
                                React.createElement("br", null),
                                React.createElement("label", { className: "form-check-label", style: { textAlign: "justify", fontSize: "small", fontWeight: "unset" } },
                                    "Para leer el aviso de privacidad de datos completo dar clic ",
                                    React.createElement("a", { href: "/aviso-privacidad", target: "_blank", style: { textDecoration: "underline", color: "#223163", cursor: "pointer" } }, "aqu\u00ED"),
                                    "."))),
                        React.createElement("br", null),
                        React.createElement("div", null,
                            React.createElement("label", { style: { fontSize: "large" } },
                                "(",
                                React.createElement("span", { className: "required-field" }, "*"),
                                ") Campos requeridos")))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("div", { className: "form-group row", id: "siguiente-interes", style: { float: "right" } },
                    React.createElement("button", { type: "button", name: "prev-interes-button", id: "prev-interes-button", className: "btn btn-info buttonSpace", onClick: this.props.retrocederSeccion }, "Anterior"),
                    React.createElement("button", { type: "submit", className: "btn btn-success buttonSpace" }, "Guardar")))));
    };
    return InformacionIntereses;
}(React.Component));
exports.InformacionIntereses = InformacionIntereses;
//# sourceMappingURL=InformacionInteres.js.map